export default __webpack_public_path__ + "f77a3e306ac8a4b3732aeec25be35ffd.svg";